<template>
  <div class="scheduled-reports">
    <!-- 📅 SCHEDULE MANAGEMENT HEADER -->
    <v-card elevation="4" class="mb-6 schedule-header">
      <v-card-text class="pa-6">
        <div class="mb-4">
          <h2 class="text-h4 text-primary mb-2">
            <v-icon size="32" class="mr-3">mdi-calendar-clock</v-icon>
            Reportes Programados
          </h2>
        </div>

        <!--
          P13-V5A-R5 · RETIRED. Los cuatro contadores del encabezado ("Activas" 12, "Pausadas" 3,
          "Ejecutadas Hoy" 8, "Éxito Rate" 97 %) eran un array literal, y no coincidían siquiera
          con la tabla que había debajo, que listaba tres programaciones. El botón "Nueva
          Programación" abría un formulario completo que, al confirmar, esperaba 2 s con un
          setTimeout y añadía la programación a un array en memoria: nada se guardaba y ninguna
          ejecución quedaba agendada, de modo que el usuario salía creyendo haber programado un
          envío que nunca ocurriría. Este componente no importa ningún cliente HTTP y no existe
          productor: bajo reportes el backend sólo monta /api/reports/organizational
          (src/app.js:568), sin ninguna superficie de programación. Una tarjeta sin productor se
          retira, no se rellena.
        -->
        <div data-testid="scheduled-reports-stats-retired">
          <v-alert type="info" variant="tonal" density="compact">
            Estas cifras no tienen un productor canónico y fueron retiradas en P13-V5A-R5. La
            programación automática de reportes no está disponible.
          </v-alert>
        </div>
      </v-card-text>
    </v-card>

    <!-- 🔄 ACTIVE SCHEDULES -->
    <v-card elevation="4" class="mb-6">
      <v-card-title class="pa-6 bg-gradient-info text-white">
        <v-icon class="mr-3">mdi-play-circle</v-icon>
        <span class="text-h5">Programaciones Activas</span>
      </v-card-title>

      <!--
        P13-V5A-R5 · RETIRED. La tabla mostraba tres programaciones literales ("Dashboard
        Ejecutivo" diario, "Reporte Field Supervisors" semanal y "Análisis Financiero" mensual),
        con próximas ejecuciones calculadas en el montaje y con destinatarios de correo
        inventados. Sus acciones eran igual de falsas: "Ejecutar ahora" esperaba 3 s con un
        setTimeout y escribía en el historial una ejecución "Completado" de 2.1s y 3.2 MB que
        nunca sucedió; pausar, reanudar y eliminar sólo cambiaban el array en memoria y se
        perdían al recargar. Publicar destinatarios y horarios de envío inexistentes es afirmar
        que alguien recibirá un correo que nadie va a mandar.
      -->
      <v-card-text class="pa-6" data-testid="scheduled-reports-active-retired">
        <v-alert type="info" variant="tonal" density="compact">
          Estas programaciones no tienen un productor canónico y fueron retiradas en P13-V5A-R5.
          No hay ninguna generación ni distribución de reportes agendada en el sistema.
        </v-alert>
      </v-card-text>
    </v-card>

    <!-- 📊 EXECUTION HISTORY -->
    <v-card elevation="4" class="mb-6">
      <v-card-title class="pa-6">
        <v-icon color="info" class="mr-3">mdi-history</v-icon>
        <span class="text-h5">Historial de Ejecuciones</span>
      </v-card-title>

      <!--
        P13-V5A-R5 · RETIRED. El historial era un array literal de cuatro ejecuciones con
        duración, número de destinatarios y tamaño de archivo (2.3s / 5 / 2.4 MB, 4.1s / 12 /
        5.7 MB, un fallo con "Error de conexión con la base de datos", 1.9s / 8 / 1.2 MB), con
        marcas de tiempo relativas al montaje para que pareciera reciente. El filtro
        Todos/Exitosos/Fallidos filtraba ese mismo array, y los botones "Descargar" y
        "Reintentar" sólo escribían en la consola: no había archivo que descargar ni ejecución
        que reintentar, porque ninguna había ocurrido.
      -->
      <v-card-text class="pa-6" data-testid="scheduled-reports-history-retired">
        <v-alert type="info" variant="tonal" density="compact">
          Este historial no tiene un productor canónico y fue retirado en P13-V5A-R5. El registro
          de ejecuciones de reportes programados no está disponible.
        </v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup lang="ts">
// P13-V5A-R5 · RETIRED. Este componente no realizaba ni una sola llamada al backend: todo su
// estado era literal y todas sus acciones eran simuladas con setTimeout. Se eliminan
// `scheduleStats`, `activeSchedules`, `executionHistory`, `availableReports`, `scheduleHeaders`,
// `newSchedule`, `frequencyOptions`, `formatOptions`, el computado `filteredExecutions` y el
// estado del diálogo (`createScheduleDialog`, `scheduleFormValid`, `creatingSchedule`,
// `historyFilter`), junto con los manejadores `createSchedule()`, `runNow()`, `pauseSchedule()`,
// `resumeSchedule()`, `editSchedule()`, `deleteSchedule()`, `downloadExecution()`,
// `retryExecution()` y los formateadores `getFrequencyColor()`, `getFrequencyIcon()`,
// `formatDateTime()` y `getTimeUntilNext()`. Quedan sin uso y se eliminan las importaciones de
// `vue` y de `date-fns` (incluido su locale `es`).
</script>

<style scoped lang="scss">
.scheduled-reports {
  .schedule-header {
    border-radius: 16px;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  }

  .bg-gradient-info {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }
}
</style>
